import React from 'react'
import { trackCTAClick } from 'utils/analytics'
import GoogleLoginButton from 'components/shared/GoogleLoginButton'
import { localePath } from 'utils/localePath';

/**
 * CTA Banner for Tools pages
 * Promotes TutorNetworking teacher collaboration network
 */
const CtaBanner = ({ translations = {}, userSignedIn }) => {
  const t = (key, defaultValue) => translations[key] || defaultValue

  return (
    <div className="bg-gradient-to-r from-[#3366FF] to-[#2952CC] rounded-xl shadow-lg p-8 text-white">
      <div className="max-w-3xl mx-auto text-center">
        <div className="mb-4">
          <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold mb-3">
          {t('cta_title', 'Join the Chinese Teacher Network')}
        </h2>
        <p className="text-lg text-white/90 mb-6">
          {t('cta_description', 'Collaborate with fellow teachers, share student referrals, exchange teaching resources, and build professional connections.')}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {userSignedIn ? (
            <a
              // eslint-disable-next-line no-restricted-syntax -- the backstage has no locale routes, so a prefix here is a 404
              href="/dashboard"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#3366FF] font-semibold rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() => trackCTAClick('teacher_go_to_dashboard', 'tools_cta_banner', '/dashboard')}
            >
              {t('cta_primary', 'Join the Community')}
            </a>
          ) : (
            <GoogleLoginButton
              role="teacher"
              label={t('cta_primary', 'Join the Community')}
              onSubmit={() => trackCTAClick('teacher_signup', 'tools_cta_banner', '/users/auth/google_oauth2?role=teacher')}
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-[#3366FF] font-semibold rounded-lg hover:bg-gray-100 transition-colors border-0"
            />
          )}
          <a
            href={localePath("/faq")}
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-white/10 transition-colors"
          >
            {t('cta_secondary', 'Learn More')}
          </a>
        </div>
      </div>
    </div>
  )
}

export default CtaBanner
